import { registerPlugin } from '@capacitor/core';

const TikTokEvents = registerPlugin('TikTokEvents', {
  web: () => import('./web.js').then((m) => new m.TikTokEventsWeb()),
});

export { TikTokEvents };
